import React, {Component } from "react"
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd'


import { Form, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 


interface SystemOrderProps {
  systemOrder: string;
  srcSystems: any;
  handleSaveSystemOrderChanges: (data: any) => void;
}

interface FieldGrpListState {
  systemOrderList: any;
  availableSrcSysList: any;
}

class SurvivorshipSystemOrder extends Component<SystemOrderProps, FieldGrpListState> {
  constructor(props: SystemOrderProps) {
    super(props);
    let systemOrderList = this.props.systemOrder ? this.props.systemOrder.split(';').map((m:any)=>{
     
      let mSrc = this.props.srcSystems.filter((f:any)=>{return f.id == m})[0];

      return mSrc?{code: mSrc.code, name: mSrc.name, id: mSrc.id}: null 
    }).filter((m)=>{return m}) : [];
    
    let availableSrcSysList = this.props.srcSystems.map((m:any)=>{     
      let mSrc = systemOrderList.filter((f:any)=>{return f.id == m.id})[0];
      return !mSrc?{code: m.code, name: m.name, id: m.id}: null 
    }).filter((m:any)=>{return m});
    
    this.state = {
	  systemOrderList,
      availableSrcSysList
    };
  }
  
  componentDidUpdate(prevProps: SystemOrderProps) {
    if (prevProps.srcSystems !== this.props.srcSystems || prevProps.systemOrder !== this.props.systemOrder) {
        let systemOrderList = this.props.systemOrder ? this.props.systemOrder.split(';').map((m:any)=>{
        let mSrc = this.props.srcSystems.filter((f:any)=>{return f.id == m})[0];
        return mSrc?{code: mSrc.code, name: mSrc.name, id: mSrc.id}: null 
      }).filter((m)=>{return m}) : [];
      
      let availableSrcSysList = this.props.srcSystems.map((m:any)=>{     
        let mSrc = systemOrderList.filter((f:any)=>{return f.id == m.id})[0];
        return !mSrc?{code: m.code, name: m.name, id: m.id}: null 
      }).filter((m:any)=>{return m});

      this.setState({
        systemOrderList,
        availableSrcSysList
      });
    }
  }
  
  // Function to handle drag end
  onDragEnd = (result: DropResult) => {
    const { destination, source } = result;

    // If no destination, don't do anything
    if (!destination) {
      return;
    }

    // If the item is dropped back in the same place, do nothing
    if (destination.index === source.index) {
      return;
    }

    // Rearrange the list
	
    const items = Array.from(this.state.systemOrderList);
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);
    this.setState({ systemOrderList: items });
      
    let systemOrder = items.map((m:any)=>{return m.id}).join(';');
	this.props.handleSaveSystemOrderChanges(systemOrder);
  };
  
   
   handleDeleteSystemOrderData = (dataIndx:number) =>{
	confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure you want to delete this item?',
	  closeOnEscape: false,
	  closeOnClickOutside: false,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
			const items = Array.from(this.state.systemOrderList);
			items.splice(dataIndx, 1);
            
            let availableSrcSysList = this.props.srcSystems.map((m:any)=>{     
              let mSrc = items.filter((f:any)=>{return f.id == m.id})[0];
              return !mSrc?{code: m.code, name: m.name, id: m.id}: null 
            }).filter((m:any)=>{return m});
            
			this.setState({ systemOrderList: items, availableSrcSysList });
            let systemOrder = items.map((m:any)=>{return m.id}).join(';');
	        this.props.handleSaveSystemOrderChanges(systemOrder);
		  }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
		
  }
  
  handleAddSystemOrderData = (dataIndx:number) =>{
    
    const items = Array.from(this.state.systemOrderList);
    items.push(this.state.availableSrcSysList[dataIndx]);
    let availableSrcSysList = this.props.srcSystems.map((m:any)=>{     
      let mSrc = items.filter((f:any)=>{return f.id == m.id})[0];
      return !mSrc?{code: m.code, name: m.name, id: m.id}: null 
    }).filter((m:any)=>{return m});

    this.setState({ systemOrderList: items, availableSrcSysList });
    
    let systemOrder = items.map((m:any)=>{return m.id}).join(';');
    this.props.handleSaveSystemOrderChanges(systemOrder);
    
  }
  
  
  handleSave = ()=>{
	
  }
  
  

  render() {
	//const fixedWidthStyle = { width: '240px' }; // Set desired width
	
    return (
		<div className="mt-2">
			
          <Card>
            <Card.Body>	
                <Form.Label className="my-2" style={{fontSize:'15px', color:'blueviolet'}}>Ranked Sources</Form.Label>
                <div className="mb-1" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                <DragDropContext onDragEnd={this.onDragEnd} >
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef} className="">
                          {this.state.systemOrderList && this.state.systemOrderList.map((item:any, index:number) => (
                            <Draggable key={item.code} draggableId={item.code} index={index}>
                              {(provided) => (
                                <Card
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="mb-1"

                                >
                                  <Card.Body className="py-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex justify-content-start align-items-center">
                                          <div className="" style={{paddingRight: '15px'}}>
                                              <Form.Label className="mb-0" style={{fontSize:'13px'}}>{index + 1}</Form.Label> 
                                          </div>
                                          <Form.Label className="mb-0" style={{fontSize:'13px'}}>{item.name}</Form.Label> 
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <Button 
                                              variant="" 
                                              style={{ padding: 0, marginTop: '-10px', marginLeft:'5px' }} 
                                              onClick={() => this.handleDeleteSystemOrderData(index)}
                                            >
                                              <FontAwesomeIcon icon={faTrash} style={{ fontSize: '12px', color:'grey' }}  />
                                            </Button>
                                        </div>
                                    </div>                                    
                                  </Card.Body>
                                </Card>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                </DragDropContext>
              </div>
            </Card.Body>
            
            <Card.Body >
              <Form.Label className="my-2" style={{fontSize:'15px', color:'blueviolet'}}>Available Sources</Form.Label>
              
              <div className="mb-1" style={{ maxHeight: '220px', overflowY: 'auto' }}>
              {this.state.availableSrcSysList && this.state.availableSrcSysList.map((item:any, index:number) => (
                  
                  <Card className="mb-1" >
                    <Card.Body className="py-3">
                      <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex justify-content-start align-items-center">
                            <Form.Label className="mb-0" style={{fontSize:'13px'}}>{item.name}</Form.Label> 
                          </div>
                          <div className="d-flex justify-content-end align-items-center">
                              <Button 
                                variant="" 
                                style={{ padding: 0, marginTop: '-10px', marginLeft:'5px' }} 
                                onClick={() => this.handleAddSystemOrderData(index)}
                              >
                                <FontAwesomeIcon icon={faPlus} style={{ fontSize: '12px', color:'grey' }}  />
                              </Button>
                          </div>
                      </div>                                    
                    </Card.Body>
                    </Card>
                
                ))}
                </div>  
            </Card.Body>

          </Card>
		</div>
    );
  }
}


export default SurvivorshipSystemOrder;